import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { MailFolderWithCount } from '../folder-management-modal/folder-management-modal.component';

@Component({
  selector: 'app-move-to-folder-modal',
  templateUrl: './move-to-folder-modal.component.html',
  styleUrls: ['./move-to-folder-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoveToFolderModalComponent implements OnInit {
  public folders: MailFolderWithCount[] = [];
  public isLoading: boolean = false;
  public selectedFolderId: number | null = null;
  public errorMessage: string = '';

  // Input: message IDs to move
  public messageIds: number[] = [];

  // Output: emits the selected folder ID (null = Inbox)
  public onFolderSelected: Subject<number | null> = new Subject();
  public onClose: Subject<void> = new Subject();

  private readonly apiUrl = '/api/MailFolder';

  constructor(
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadFolders();
  }

  loadFolders(): void {
    this.isLoading = true;
    this.errorMessage = '';
    this.changeDetectorRef.markForCheck();

    this.http.get<MailFolderWithCount[]>(`${this.apiUrl}/all`).subscribe({
      next: (folders) => {
        this.folders = folders;
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      },
      error: (error) => {
        console.error('Failed to load folders:', error);
        this.errorMessage = 'Грешка при зареждане на папките';
        this.isLoading = false;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  selectFolder(folderId: number | null): void {
    this.selectedFolderId = folderId;
    this.changeDetectorRef.markForCheck();
  }

  confirm(): void {
    this.onFolderSelected.next(this.selectedFolderId);
    this.activeModal.close(this.selectedFolderId);
  }

  close(): void {
    this.onClose.next();
    this.activeModal.dismiss();
  }

  getMessageCountText(): string {
    const count = this.messageIds.length;
    if (count === 1) {
      return '1 съобщение';
    }
    return `${count} съобщения`;
  }
}
